// export const getSortedValuesForColumn = (columnType, competitors) => {
//   return competitors
//     .map((competitor) => {
//       const value = parseFloat(
//         competitor.data.find((item) => item.type === columnType)?.value || "N/A"
//       );
//       return { id: competitor._id, value };
//     })
//     .filter(({ value }) => !isNaN(value))
//     .sort((a, b) => a.value - b.value);
// };

export const getSortedValuesForColumn = (columnType, competitors) => {
  const toNumber = (val) => {
    if (val === null || val === undefined || val === "") return NaN;

    return Number(String(val).replace(/,/g, "").trim());
  };

  return competitors
    .map((competitor) => {
      const raw = competitor.data.find(
        (item) => item.type === columnType
      )?.value;

      const value = toNumber(raw);

      return {
        id: competitor._id,
        value,
      };
    })
    .filter(({ value }) => !isNaN(value))
    .sort((a, b) => Number(a.value.toFixed(6)) - Number(b.value.toFixed(6)));
  // .sort((a, b) => a.value - b.value);
};

// export const assignColorsToColumn = (columnType, competitors, sortedValues) => {
//   const total = sortedValues.length;

//   // if (total < 4) {
//   //   return sortedValues.map((entry) => ({
//   //     ...entry,
//   //     color: "bg_white",
//   //   }));
//   // }

//   const bottom = sortedValues[0];
//   const secondBottom = sortedValues[1];
//   const secondTop = sortedValues[total - 2];
//   const top = sortedValues[total - 1];

//   return sortedValues.map((entry) => {
//     if (entry.id === bottom.id) return { ...entry, color: "dark_red" };
//     if (entry.id === secondBottom.id) return { ...entry, color: "light_red" };
//     if (entry.id === secondTop.id) return { ...entry, color: "light_green" };
//     if (entry.id === top.id) return { ...entry, color: "dark_green" };
//     return { ...entry, color: "bg_white" };
//   });
// };

export const assignColorsToColumn = (columnType, competitors, sortedValues) => {
  const total = sortedValues.length;

  if (total === 0) return [];

  if (total === 1) {
    return sortedValues.map((e) => ({
      ...e,
      color: "heatmap_dark_green",
    }));
  }

  if (total === 2) {
    return sortedValues.map((e, i) => ({
      ...e,
      color: i === 0 ? "heatmap_dark_red" : "heatmap_dark_green",
    }));
  }

  if (total === 3) {
    return sortedValues.map((e, i) => ({
      ...e,
      color:
        i === 0
          ? "heatmap_dark_red"
          : i === 2
          ? "heatmap_dark_green"
          : "heatmap_light_red",
    }));
  }

  // 4 or more
  const bottom = sortedValues[0];
  const secondBottom = sortedValues[1];
  const secondTop = sortedValues[total - 2];
  const top = sortedValues[total - 1];

  return sortedValues.map((entry) => {
    if (entry.id === bottom.id) return { ...entry, color: "heatmap_dark_red" };

    if (entry.id === secondBottom.id)
      return { ...entry, color: "heatmap_light_red" };

    if (entry.id === secondTop.id)
      return { ...entry, color: "heatmap_light_green" };

    if (entry.id === top.id) return { ...entry, color: "heatmap_dark_green" };

    return { ...entry, color: "heatmap_bg_white" };
  });
};
